import { Box } from '@chakra-ui/react'

export const BaseCard = ({ children, ...rest }) => {
  return (
    <Box color="black" background="white" borderColor="gray.200" borderWidth={1} borderRadius="0.5rem" {...rest}>
      {children}
    </Box>
  )
}
